import Image from 'next/image';

import { MappedProduct } from '@/fo/util/map-product-data';

import { styles } from './ProductInfo.styles';

interface ProductInfoProps {
  thumbnail?: MappedProduct['thumbnail'];
  name: MappedProduct['name'];
  baseProduct: MappedProduct;
  selectedProduct: MappedProduct;
}

export function ProductInfo({ thumbnail, name }: ProductInfoProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      {thumbnail && (
        <Image
          className={slots.image()}
          src={thumbnail.src}
          width={60}
          height={60}
          alt={thumbnail.alt}
        />
      )}
      <div className={slots.content()}>
        <h1 className={slots.name()}>
          <span className={slots.nameText()}>{name}</span>
        </h1>
      </div>
    </div>
  );
}
